import React from 'react'
import { useEffect, useState } from "react"
import Swal from "sweetalert2"
import {withRouter, useHistory} from 'react-router-dom'
import parse from 'html-react-parser'

import AcuarelaImg from '../../assets/images/acuarela.png'
import SeparadorImg from '../../assets/images/separador.png'
import SeparadorImg2 from '../../assets/images/separador2.png'
import RequisitosIcon from '../../assets/images/requisitos.svg'
import volverArribaImg from '../../assets/images/volverArriba.svg'

import {PageContainer} from './../../components/home/Container' 
import { AcuarelaSection } from '../../components/home/AcuarelaSection/Section'
import { DebesTenerEnCuentaSection } from '../../components/home/TenerEnCuentaSection/Section'
import { OfertaFormativaSection } from '../../components/home/OfertaFormativaSection/Section'
// import { Navbar } from '../../components/header/Header'
import { InformacionInstitucionalSection } from '../../components/home/InformacionInstitucionalSection/Section'
// Course videos
import vi_discapacidad from '../../assets/videos/vi_discapacidad.mp4'
import vi_Amasijos from '../../assets/videos/vi_Amasijos.mp4'
import vi_Animación from '../../assets/videos/vi_Animación.mp4'
import vi_Carraga from '../../assets/videos/vi_Carraga.mp4'
import vi_Comparsa from '../../assets/videos/vi_Comparsa.mp4'
import vi_ComparsaII from '../../assets/videos/vi_ComparsaII.mp4'
import vi_Danza from '../../assets/videos/vi_Danza.mp4'
import vi_Danza2 from '../../assets/videos/vi_Danza2.mp4'
import vi_DiseñoArtistico from '../../assets/videos/vi_DiseñoArtistico.mp4'
import vi_Gastronomia from '../../assets/videos/vi_Gastronomia.mp4'
import vi_Grabado from '../../assets/videos/vi_Grabado.mp4'
import vi_historietas_Novela_grafica from '../../assets/videos/vi_historietas_Novela_grafica.mp4'
import vi_leer2 from '../../assets/videos/vi_leer2.mp4'
import vi_LGTBIQ from '../../assets/videos/vi_LGTBIQ.mp4'
import vi_Muralismo from '../../assets/videos/vi_Muralismo.mp4'
import vi_Samples from '../../assets/videos/vi_Samples.mp4'
import vi_tejido from '../../assets/videos/vi_tejido.mp4'
import vi_Vallenato from '../../assets/videos/vi_Vallenato.mp4'
import vi_Videos from '../../assets/videos/vi_Videos.mp4'
import vi_primeraInfancia from '../../assets/videos/vi_primeraInfancia.mp4'
import HTMLReactParser from 'html-react-parser'

// Course videos

const oportunityCardData = {
    sar:'FORMACIÓN BOSARTE PARA VIVIR LA CULTURA LOCAL - CONTRATO INTERADMINISTRATIVO 489-2023 Fondo Local de Desarrollo de Bosa - Universidad Pedagógica Nacional',
    title:'¿Quieres aprovechar tu tiempo libre aprendiendo música, danza, teatro, artes plásticas, Gastronomía, artes tradicionales o audiovisuales?',
    message:'¡¡Esta es tu oportunidad!!',
    description:'Son 20 cursos de 40 horas de duración que se realizan en encuentros semanales presenciales. Dirigidos a niños, niñas, jóvenes, adultos y adultos mayores. Orientados por profesores, artistas egresados de programas de artes tanto de la Universidad Pedagógica Nacional como de otras universidades.'
}
const considerData = [
    {
        id:'0',
        title:'¿Cómo será el proceso de formación? ¿virtual o presencial? ',
        description:'Se realizará una formación netamente presencial en espacios ubicados en varias UPZ de la localidad.'
    },
    {
        id:'1',
        title:'¿Quiénes pueden participar? ',
        description:'Niños, niñas, jóvenes, adultos y adultos mayores, comunidad indígena, comunidad afrodescendiente y cuidadores  de la localidad de BOSA.'
    },
    // {
    //     id:'2',
    //     title:'¿Cuáles son las fechas de inscripciones a los cursos? ',
    //     description:'Del 11 al 07 de noviembre de 2022. Por el sitio web o presencial en las instalaciones de la Alcaldía de BOSA.'
    // },
    {
        id:'3',
        title:'¿Qué requisitos deben cumplir? ',
        description:parse('<ol><li>Ser habitante <b>certificado</b> de la localidad BOSA.</li><br><li>Tener <b>disponibilidad de horarios</b> para asistir a los cursos de acuerdo a los horarios y lugares donde se realizan.</li><br><li>Estar en el rango de <b>edades</b> al cual está dirigido cada curso.</li></ol>')},
    {
        id:'4',
        title:'¿Se debe anexar algún documento? ',
        description: parse('Sí. Dos (2) documentos:<br><ol><li>Copia del <b>documento de identidad.</b></li><br><li>Certificado de residencia <b>(recibo de servicio público: agua o energía)</b> donde se indique la dirección y barrio con CLARIDAD.</li></ol>')},
    {
        id:'5',
        title:'¿Me puedo registrar de forma presencial?',
        description: parse('Sí. En la Alcaldía de Bosa: <b>Casa de la participación</b> (Cra 80 No. 61 - 28 sur) y <b>CDC El porvenir</b> (Cra 100 No. 52 sur - 24). <br><br><b>Horario:</b> Lunes a viernes de 10:00 am a 12 m y de 2:00 pm a 5:00 pm.')},
    {
        id:'9',
        title:'',
        description:''
    },
    {
        id:'10',
        title:'',
        description:''
    },
    {
        id:'11',
        title:'',
        description:''
    },
    {
        id:'12',
        title:'',
        description:''
    },
]
const formationData =[
    {
        id:'0',
        title:'20 cursos de formación que responden a 8 áreas artísticas y culturales:',
        description:'Componente diferencial | Literatura | Audiovisuales | Danza | Artes plásticas | Música | Teatro: modalidad comparsa | Artes tradicionales.'
    },
    {
        // id:'1',
        // title:'Inscripciones del 11 al 07 de noviembre de 2022. Lugar presencial de inscripción:',
        // description:parse('<ul><li><b style="color:#3d7699";>Casa de la Participación</b> - Alcaldía de Bosa Cra 80 K no.61-28 Sur.</li><li><b style="color:#3d7699";>Horario</b>: lunes a viernes de 10 a 12 m y de 2 a 5 pm.</li></ul>'),
    },
    // {
    //     id:'2',
    //     title:'',
    //     description:parse('<b>Casa de la Participación</b> - Alcaldía de Bosa Cra 80 K no.61-28 Sur. <br><br> Horario: lunes a viernes de 10 a 12 m y de 2 a 5 pm'),
    // },
    // {
    //     id:'3',
    //     title:'',
    //     description:''
    // },
    // {
    //     id:'4',
    //     title:'',
    //     description:''
    // },
    // {
    //     id:'5',
    //     title:'',
    //     description:''
    // },
    // {
    //     id:'6',
    //     title:'',
    //     description:''
    // },
    // {
    //     id:'7',
    //     title:'',
    //     description:''
    // },
    // {
    //     id:'8',
    //     title:'',
    //     description:''
    // },
    // {
    //     id:'9',
    //     title:'',
    //     description:''
    // },
]

const HomeScreen = () => {
    // *************************************useState
const [cursosRegistrados, setCursosRegistrados] = useState('')
const [discapacidad, setdiscapacidad] = useState(null)
const [tejido, settejido] = useState(null)
const [primeraInfancia, setprimeraInfancia] = useState(null)
const [LGTBIQ, setLGTBIQ] = useState(null)
const [historietas_Novela_grafica, sethistorietas_Novela_grafica] = useState(null)
const [Gastronomia,setGastronomia] = useState(null)
const [Amasijos, setAmasijos] = useState(null)
const [Animación, setAnimación] = useState(null)
const [DiseñoArtistico, setDiseñoArtistico] = useState(null)
const [leer, setleer] = useState(null)
const [Videos, setVideos] = useState(null)
const [Danza, setDanza] = useState(null)
const [Danza2, setDanza2] = useState(null)
const [Grabado, setGrabado] = useState(null)
const [Muralismo, setMuralismo] = useState(null)
const [Samples, setSamples] = useState(null)
const [Vallenato, setVallenato] = useState(null)
const [Carraga, setCarraga] = useState(null)
const [Comparsa, setComparsa] = useState(null)
const [ComparsaII, setComparsaII] = useState(null)

const courseData = [
    {
        id:'1',
        video:vi_discapacidad,
        backgroundColorHeader:'#4995B7',
        area:'Componente diferencial',
        // display:discapacidad <= 34 ? 'block':'none',
        capacity:18,
        type:'CURSO',
        course:'Discapacidad',
        // trimCourse:'discapacidad',
        description:parse('Implementar un espacio de formación, experimentación y creación en diferentes áreas del campo artístico, que promuevan la convivencia y den como resultado un ejercicio de montaje con miras a una muestra de proceso. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Luis Hernández',
        population:'Personas con discapacidad*. Se realizarán trabajos autónomos, se espera que el participante pueda valerse por sí mismo.',
        schedule:'Por concertar',
        requirements:'No se requiere conocimientos previos, tan solo curiosidad y mucha disposición por aprender',
        
    },
    {
        id:'2',
        video:vi_primeraInfancia,
        backgroundColorHeader:'#4995B7',
        area:'Componente diferencial',
        display:primeraInfancia <= 25 ? 'block':'none',
        capacity:0,
        type:'CURSO',
        course:'Primera Infancia',
        trimCourse:'Laboratoriodepersonajesfantasticos',
        description:parse('Desarrollar actividades que permitan fortalecer la capacidad de expresión y consciencia del cuerpo a través de canciones y juegos. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Karen Agudelo',
        population:'Padres, madres, familiares, cuidadores, niñas y niños de 0 a 5 años.',
        schedule:'Lunes y viernes de 3:00 pm a 6:00 pm.',
        requirements:'Botellas de plastico, semillas, palos de escoba, tarros de lata medianos, material para realizar titeres. Los niños deben aistir con padre o madre.',
    },
    {
        id:'3',
        video:vi_LGTBIQ,
        backgroundColorHeader:'#4995B7',
        area:'Componente diferencial',
        display:LGTBIQ <= 20 ? 'block':'none',
        capacity:8,
        type:'CURSO',
        course:'Comunidad LGTBIQ',
        trimCourse:'Laboratoriodepersonajesfantasticos',
        description:parse('Generar un interés en el conocimiento del maquillaje, entregando las herramientas necesarias para su desarrollo y su mirada social, dando a conocer las distintas posibilidades de desarrollo escénico-profesional. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Brandon King Mirque Candanoza',
        population:'Comunidad LGBTIQ',
        schedule:'Sábados 3:00 pm a 6:00 pm | Domingo 9:00 am a 12 m',
        requirements:'Set de maquillaje, sombras y contornos. Colores recomendados verde, rojo y naranja.',
    },
    {
        id:'4',
        video:vi_historietas_Novela_grafica,
        backgroundColorHeader:'#D45FEE',
        area:'Literatura',
        display:historietas_Novela_grafica <= 20 ? 'block':'none',
        capacity:9,
        type:'CURSO',
        course:'Elaboración de historietas: novela gráfica',
        trimCourse:'Leyendoimagenesydibujandopalabras',
        description:parse('Realizar una publicación con las historietas, comics e ilustraciones que se elaboren por cada uno de los participantes, fruto de las herramientas, insumos y conocimientos adquiridos a lo largo del taller. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'María Alejandra Arteaga',
        population:'Jóvenes y adultos',
        schedule:'Martes y viernes de 3:00 pm a 6:00 pm',
        requirements:'Ninguno',
        
    },
    {
        id:'5',
        video:vi_Animación,
        backgroundColorHeader:'#FF7C66',
        area:'Audiovisuales',
        display:Animación <= 20 ? 'block':'none',
        capacity:9,
        type:'CURSO',
        course:'Animación',
        trimCourse:'Sombraschinasteatrodeobjetosycomic',
        description:parse('Crear un producto audiovisual donde se evidencie alguna o varias técnicas de animación vistas en el proceso. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Sebastián Camilo Niño Ramírez',
        population:'Jóvenes y adultos',
        schedule:'Lunes y viernes de 3:00 pm a 6:00 pm',
        requirements:'Cámara profesional, semi o celular con cámara, PC o portátil, cuaderno u hojas, lápiz, hilo y cartulina.',
    },
    {
        id:'6',
        video:vi_DiseñoArtistico,
        backgroundColorHeader:'#FF7C66',
        area:'Audiovisuales',
        display:DiseñoArtistico <= 25 ? 'block':'none',
        capacity:0,
        type:'CURSO',
        course:'Diseño Artístico',
        trimCourse:'Creacionaudiovisual',
        description:parse('Aprender a realizar piezas comunicativas para eventos o espacios culturales. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Johan Sebastián Charry',
        population:'Jóvenes y adultos',
        schedule:'Lunes y miercoles de 8:00 am a 11:00 am',
        requirements:'Cámara profesional, semi o celular con cámara, PC o portátil.',
        
    },
    {
        id:'7',
        video:vi_Videos,
        backgroundColorHeader:'#FF7C66',
        area:'Audiovisuales',
        display:Videos <= 25 ? 'block':'none',
        capacity:7,
        type:'CURSO',
        course:'Videos: creación y producción',
        trimCourse:'Quelindoesvolversumerce',
        description:parse('Crear un producto audiovisual en formato de mini o micro documental que evidencie lo aprendido en el taller y que sea con una temática acorde a la localidad, lo que propiciará reconstrucción de historias barriales, aportando a la recuperación de la memoria local. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Johan Sebastián Charry',
        population:'Jóvenes y adultos',
        schedule:'Jueves y viernes de 1:00 pm a 4:00 pm',
        requirements:'Cámara profesional, semi o celular con cámara, PC o portátil con software y requisitos mínimos del sistema.',
    },
    {
        id:'8',
        video:vi_Danza,
        backgroundColorHeader:'#6c5ce7',
        area:'Danza',
        display:Danza <= 0 ? 'block':'none',
        // capacity:!Danza ? 15 : 25 - Danza,
        capacity:0,
        type:'CURSO',
        course:'Danza Adulto Mayor I',
        trimCourse:'Danzandomemeencuentro',
        description:parse('Brindar un espacio para la exploración del cuerpo como vehículo de interacción social que, a través del ejercicio de la danza tradicional colombiana, construya las tareas físicas, creativas e interpretativas propias del género que enmarca este taller. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Nelson Soledad',
        population:'Adultos mayores de la localidad BOSA con o sin experiencia en danza.',
        schedule:'Martes y jueves de 3:00 pm a 6:00 pm',
        requirements:'Ninguno',
    },
    {
        id:'9',
        video:vi_Danza2,
        backgroundColorHeader:'#6c5ce7',
        area:'Danza',
        display:Danza2 <= 24 ? 'block':'none',
        capacity:0,
        type:'CURSO',
        course:'Danza Adulto Mayor II',
        trimCourse:'Circocontemporaneo',
        description:parse('Acercar a los y las participantes del taller a herramientas corporales y compositivas del campo de la danza que potencien sus puestas en escena y su ejercicio de la danza tradicional colombiana. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Nelson Soledad',
        population:'Adultos mayores de la localidad BOSA que han hecho parte de procesos de formación en danza previamente (curso de danza para adulto mayor año 2020 y 2021).',
        schedule:'Lunes y sábado 3:00 pm a 6:00 pm',
        requirements:'Experiencia previa en procesos de formación en danza.',
    },
    {
        id:'10',
        video:vi_Grabado,
        backgroundColorHeader:'#f6b93b',
        area:'Artes Plásticas',
        display:Grabado <= 24 ? 'block':'none',
        capacity:15,
        type:'CURSO',
        course:'Grabado y realización de publicaciónes rústicas',
        trimCourse:'Teatrofisico',
        description:parse('Realización de un proyecto personal con la técnica de linograbado por parte de cada uno de los participantes con las herramientas, insumos y conocimientos adquiridos durante el desarrollo del taller. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'María Alejandra Arteaga',
        population:'Jóvenes y adultos',
        schedule:'Martes y viernes de 12m a 3:00 pm',
        requirements:'Ninguno',
    },
    {
        id:'11',
        video:vi_Muralismo,
        backgroundColorHeader:'#f6b93b',
        area:'Artes Plásticas',
        display:Muralismo <= 24 ? 'block':'none',
        capacity:0,
        type:'CURSO',
        course:'Muralismo expandido',
        trimCourse:'MemoriaSaboryColor',
        description:parse('Intervención de un espacio público a partir de la creación colectiva de una imagen o pieza gráfica. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Niyer Muñoz',
        population:'Niñxs, jóvenes y adultos',
        schedule:'Viernes de 3:00 pm a 6:00 pm y sábados de 9:00 am a 12m',
        requirements:'Ninguno',
    },
    {
        id:'12',
        video:vi_Samples,
        backgroundColorHeader:'#10ac84',
        area:'Música',
        display:Samples <= 24 ? 'block':'none',
        capacity:9,
        type:'CURSO',
        course:'Samples y Beats para la escena Hip hop y música electrónica',
        trimCourse:'Samples',
        description:parse('Aportar a l@s artistas de la escena hip-hop y música electrónica, y población en general de BOSA, nuevo conocimiento sobre creación de pistas instrumentales y beats. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Sebastián Márquez',
        population:'Jóvenes y adultos',
        schedule:'Martes y jueves de 8:00 am a 11:00 am',
        requirements:'Ninguno',
    },
    {
        id:'13',
        video:vi_Vallenato,
        backgroundColorHeader:'#10ac84',
        area:'Música',
        display:Vallenato <= 24 ? 'block':'none',
        capacity:17,
        type:'CURSO',
        course:'Curso de Vallenato',
        trimCourse:'Vallenato',
        description:parse('Interactuar, compartir y visibilizar una de las tradiciones musicales autóctonas de la zona norte de nuestro país. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Fredy Aguiar',
        population:'Niños, jóvenes y adultos',
        schedule:'Lunes a miercoles de 3:00 pm a 6:00 pm',
        requirements:'Ninguno',
    },
    {
        id:'14',
        video:vi_Carraga,
        backgroundColorHeader:'#10ac84',
        area:'Música',
        display:Carraga <= 24 ? 'block':'none',
        capacity:7,
        type:'CURSO',
        course:'Iniciación a la Carraga',
        trimCourse:'Carraga',
        description:parse('Acercar a los participantes al conocimiento, ejecución y disfrute de las músicas campesinas del eje andino oriental. Teniendo como base los principios instrumentales, vocales y líricos de estas músicas en su contexto. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Sebastián Marquéz',
        population:'Niños, mayores de 7 años, jóvenes y adutos',
        schedule:'Martes y jueves de 11:00 am a 2:00 pm',
        requirements:'Ninguno',
    },
    {
        id:'21',
        video:vi_Comparsa,
        backgroundColorHeader:'#222f3e',
        area:'Teatro Comparsa',
        display:Comparsa <= 25 ? 'block':'none',
        capacity: 10,
        type:'CURSO',
        course:'Comparsa Iniciación',
        trimCourse:'Comparsa',
        description:parse('Implementar talleres artísticos interdisciplinares que potencien la capacidad creativa, comunicativa y expresiva de los niños, niñas y jóvenes de la localidad; que permitan la creación de una comparsa a modo de carnaval. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Caterin Castillo Monroy',
        population:'Niños y jóvenes',
        schedule:'Miércoles y viernes de 3:00 pm a 6:00 pm',
        requirements:'Ninguno',
    },
    {
        id:'15',
        video:vi_ComparsaII,
        backgroundColorHeader:'#222f3e',
        area:'Teatro Comparsa',
        display:ComparsaII <= 25 ? 'block':'none',
        capacity: 12,
        type:'CURSO',
        course:'Comparsa Avanzada',
        trimCourse:'ComparsaII',
        description:parse('Afianzar los conocimientos artísticos y corporales para la creación de ejercicios propios de comparsa, desarrollando partituras de movimiento, desplazamientos, creación de objetos, máscaras o escenografías para calle. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Ofir Durán',
        population:'Jóvenes y adultos',
        schedule:'Sábado de 2:00 pm a 5:00 pm y domingos de 9:00 am a 12m',
        requirements:'Ninguno',
    },
    {
        id:'16',
        video:vi_tejido,
        backgroundColorHeader:'#ee5253',
        area:'Artes Tradicionales',
        display:tejido <= 34 ? 'block':'none',
        capacity:0,
        type:'CURSO',
        course:'Tejido Hiloramas',
        trimCourse:'tejido',
        description:parse('Creación, diseño y construcción de un trabajo plástico creativo a partir de la técnica del hilorama y el tejido. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Julio Cesar Bernal Q.',
        population:'Jóvenes y Adultos',
        schedule:'Martes y jueves de 8:00 am a 11:00 am',
        requirements:'Ninguno',
    },
    // {
    //     id:'17',
    //     video:,
    //     backgroundColorHeader:'#ee5253',
    //     area:'Artes Tradicionales',
    //     display:tejido <= 34 ? 'block':'none',
    //     capacity:25,
    //     type:'CURSO',
    //     course:'Creando caricaturas',
    //     trimCourse:'tejido',
    //     description:'Creación de caricaturas a través de actividades experienciales, lúdicas y significativas ',
    //     teacher:'Julio Bernal',
    //     population:'Niños y Jovenes de 8 a 14 años en adelante',
    //     schedule:'Lunes y Miércoles de 4 pm a 6 pm',
    //     requirements:'Contar con herramientas en casa como: Lapices H y B (desde el 4H hasta el 6B, almenos uno de cada familia). 2. Lápices de colores, 3. Regla. 4. Papel bond o soportes similares',
        
    // },
    {
        id:'18',
        video:vi_Gastronomia,
        backgroundColorHeader:'#ee5253',
        area:'Artes Tradicionales',
        display:Gastronomia <= 24 ? 'block':'none',
        capacity:0,
        type:'CURSO',
        course:'Gastronomía postres tradicionales',
        trimCourse:'Gastronomia',
        description:parse('Crear y compartir sabores y saberes colectivos, a partir de recetas ancestrales sobre postres tradicionales propios o foráneos. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Ofir Durán',
        population:'Jóvenes y adultos',
        schedule:'Lunes a viernes de 3:00 pm a 6:00 pm',
        requirements:'Ninguno',
        
    },
    {
        id:'19',
        video:vi_Amasijos,
        backgroundColorHeader:'#ee5253',
        area:'Artes Tradicionales',
        display:Amasijos <= 24 ? 'block':'none',
        capacity:0,
        // capacity:!Amasijos ? 25 : 25 - Amasijos,
        type:'CURSO',
        course:'Gastronomia Amasijos',
        trimCourse:'Amasijos',
        description:parse('Enseñar a la población técnicas básicas, para la preparación de Amasijos tradicionales Colombianos. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Gina Paola Zapata',
        population:'Jóvenes y adultos',
        schedule:'Miercoles y jueves de 3:00 pm a 6:00 pm',
        requirements:'Ninguno',
    },
    {
        id:'20',
        video:vi_leer2,
        backgroundColorHeader:'#ee5253',
        area:'Artes Tradicionales',
        // display:leer <= 34 ? 'block':'none',
        // capacity:!leer ? 20 : 35 - leer,
        capacity:17,
        type:'CURSO',
        course:'Aprendiendo a leer el territorio de BOSA',
        trimCourse:'leer',
        description:parse('Compartir experiencias y conocimiento en torno a la investigación en general y en particular la investigación artística y cultural. Todo esto aplicada a la creación y construcción de una cartografía artística y cultural de la localidad. <a class="btn btn-primary" target="_blank" href="https://forms.gle/f6ahaCTSdsErTBhK8"> <button>Regístrese aquí</button></a>'),
        teacher:'Marco Antonio Guerrero',
        population:'Jóvenes y adultos',
        schedule:'Lunes y martes de 3:00 pm a 6:00 pm',
        requirements:'Ninguno',
    }
]

// *************************************useEffect
    const history = useHistory()
    const handleRegister = (course, trimCourse)=>{
        // window.location.href target="_blank" = 'https://forms.gle/f6ahaCTSdsErTBhK8'
        window.open('https://forms.gle/f6ahaCTSdsErTBhK8', '_blank');
        // history.push({
        //     pathname:'https://platzi.com/',
        //     state:{course, trimCourse}
        // })
    }
    const handleTop = ()=>{
        window.scrollTo({ top: 0,behavior: 'smooth' })
    }
    return (
    <>
        {/* <Navbar/> */}
        <PageContainer>
            <AcuarelaSection 
                src={AcuarelaImg}
                sar={oportunityCardData.sar}
                title={oportunityCardData.title}
                message={oportunityCardData.message}
                description={oportunityCardData.description}
                separator={SeparadorImg} />
            <InformacionInstitucionalSection
                title='Formación sin costo'
                data={formationData}/>
            <DebesTenerEnCuentaSection
                title='Requisitos'
                subtitle=''
                data={considerData}
                separator={SeparadorImg2}/>
            <OfertaFormativaSection
                title='Oferta formativa'
                warning='Antes de inscribirse a algún curso, consulte los requisitos'
                icon={RequisitosIcon}
                data={courseData}
                onClick={(course, trimCourse)=> handleRegister(course, trimCourse)}
                backToTopImg={volverArribaImg}
                backToTopClick={handleTop}/>
        </PageContainer>
    </>
    )
}


export default withRouter(HomeScreen)
